import WhatsAppIcon from '../../components/WhatsAppIcon';
import heroImage from '../../assets/images/hero_image.png';

const WA_URL =
  "https://wa.me/5511986304696?text=Ol%C3%A1!%20Vim%20pelo%20site%20da%20l'ora%20e%20gostaria%20de%20uma%20proposta.";

export default function Hero() {
  return (
    <section className="hero wrap" id="inicio">
      <div className="eyebrow">Imagem. Conteúdo. Estratégia.</div>
      <div className="hero-top">
        <h1>
          Sua marca merece<br />
          ser <em>lembrada.</em>
        </h1>
        <div className="hero-copy">
          <p>
            Nós tornamos isso realidade para o seu negócio. Vídeos, fotos e
            presença digital com a identidade única da sua marca.
          </p>
          <a className="btn" href={WA_URL} target="_blank" rel="noopener noreferrer">
            <WhatsAppIcon />
            <span>
              Quero uma proposta<span className="arrow" aria-hidden="true">→</span>
            </span>
          </a>
        </div>
      </div>
      <div className="hero-image">
        <img
          src={heroImage}
          alt="Produção audiovisual e fotográfica l’ora"
          width="1360"
          height="430"
        />
        <span className="image-label">DA IDEIA AO CONTEÚDO NO AR.</span>
      </div>
      <div className="strip">
        <span>VIDEOMAKER &amp; STORYMAKER</span>
        <span>FOTOGRAFIA</span>
        <span>SOCIAL MEDIA</span>
        <span>DESIGN CRIATIVO</span>
        <span>TRÁFEGO PAGO</span>
      </div>
    </section>
  );
}
